import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Input,
  Switch,
  Textarea,
  Typography,
} from "@material-tailwind/react";
import React, {useState} from "react";
import SelectInput from "../system/select";
import {BsCheckCircle} from "react-icons/bs";
import {Toaster} from "../../helper/Toaster";
import {getUsersNameAndRole} from "../../services/user/role";
import dict from "../../helper/dict";
import {submitAdminServiceSendSendSms} from "../../services/admin_service/send_notification";


export function SendNotification() {

  const [userId, setUserId] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [sendSms, setSendSms] = useState(false);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const save = async () => {
    if (loading) return; // Prevent multiple simultaneous requests
    
    const data = {
      user_id: userId,
      title: title,
      description: description,
      sms: sendSms ? "yes" : "no",
    };
    
    try {
      setLoading(true);
      let result = await submitAdminServiceSendSendSms(data);

      if (result.status === 200) {
        setSent(true);
      } else {
        Toaster.failure(null, <Typography variant="small">
          {result.data?.message || 'خطا در ارسال پیام'}
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant="small">
        {err.message || 'خطا در ارسال پیام'}
      </Typography>);
      console.error('Send notification error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mr-8">
      <Card className="pt-8 md:w-1/2">
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex text-center items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">ارسال پیام</Typography>
          </div>

          {sent &&
            <div className="">
              <Alert className="flex flex-row my-4">
                <Typography className="flex font-semibold">
                  <BsCheckCircle className="flex ml-2 text-xl"/>
                  پیام با موفقیت ارسال گردید.
                </Typography>
              </Alert>
            </div>
          }

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <div className="grid grid-cols-1">

            <div className="flex w-full mb-4">
              <SelectInput
                label={"کاربر"}
                defaultValue={userId}
                autoLoadService={getUsersNameAndRole}
                autoLoadRender={({name, role_title}) => {
                  return name + " - " + dict(role_title)
                }}
                onChange={setUserId}
              />
            </div>

            <div className="flex w-full my-4">
              <Input
                label="عنوان"
                variant="standard"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </div>

            <div className="flex w-full mb-4">
              <Textarea
                label="متن پیام"
                type="number"
                variant="standard"
                step="5"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </div>

            <div className="flex w-full mb-4">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    ارسال اس ام اس
                  </Typography>
                }
                checked={sendSms}
                onChange={(e) => {
                  setSendSms(e.target.checked)
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>


          </div>
        </CardBody>

        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={loading}>
            {loading ? 'در حال ارسال...' : 'ارسال پیام'}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}